import { CardXResponse } from "./CardXResponse";

export class CardXResponseSaveRequest{

    public customerNumber: any;
    public userName: string;
    public cardXresponse: CardXResponse;

    constructor()
    {
        this.userName = null;
        this.customerNumber = null;
        this.cardXresponse = null;
    }
    
}